import storeConfig from './../../assets/store-config.json';

export function mediaAppender({ id, media, image_url, file_url }) {
  var mediaContainer = document.getElementById(id);

  if (media.includes(`MediaImage`)) {
    mediaContainer.innerHTML = `<img src="${image_url}" alt="" />`;
  } else {
    mediaContainer.innerHTML = `<video autoPlay loop muted playsinline frameborder="0" allowfullscreen><source src="${file_url}" /></video>`;
  }
};

export function appendAll(liquidData) {
  Object.keys(liquidData).forEach((key) => {
    const item = liquidData[key];

    mediaAppender(item);
  });
}

export function getRegion(shopUrl) {
  let region = null;

  switch (shopUrl) {
    case `https://www.memobottle.com.au`:
    case `https://www.memobottle.com.au/`:
    case `www.memobottle.com.au`:
      region = `au`;
      break;

    case `https://www.memobottle.eu.com`:
    case `https://www.memobottle.eu.com/`:
    case `www.memobottle.eu.com`:
      region = `eu`;
      break;

    case `https://www.memobottle.uk`:
    case `https://www.memobottle.uk/`:
    case `www.memobottle.uk`:
      region = `uk`;
      break;

    case `https://www.memobottle.com`:
    case `https://www.memobottle.com/`:
    case `www.memobottle.com`:
      region = `gl`;
      break;

    case `https://www.memobottle.us`:
    case `https://www.memobottle.us/`:
    case `www.memobottle.us`:
      region = `us`;
      break;

    default:
      break;
  }

  return region;
}

export function getStoreConfig(shopUrl) {
  const region = getRegion(shopUrl);

  if (!region) {
    // todo: error
    return null;
  }

  const config = storeConfig?.[region];

  if (!config) {
    // todo: error
    return null;
  }
 
  return config;
}